module.exports = function () {}



//////////////////
// WEBPACK FOOTER
// ./~/empty-functions/noop.js
// module id = 20
// module chunks = 0